module.exports = __webpack_public_path__ + "img/vizilo80.a2ecfc8a.jpg";